<button id="purchaseOrderCreateModal_cancel" type="button" class="close" data-dismiss="modal" aria-label="Close" tabindex="-1" (click)="cancel()">
  <span aria-hidden="true">&times;</span>
</button>
<ng-container *ngLet="{
  groups: groups$ | async
} as vm">
  <form #ngForm="ngForm" (ngSubmit)="ngForm.form.valid && submit()">
    <fieldset class="modal-scrollable-content" [disabled]="busy$ | async">
      <div class="modal-header">
        <h4 *ngIf="!isOnlyHotFlagCreatePO" class="modal-title">Create Purchase Orders</h4>
        <h4 *ngIf="isOnlyHotFlagCreatePO" class="modal-title">Create Req or Purchase Orders</h4>
        <span *ngIf="busy$ | async" class="countLoader"></span>
      </div>
      <div class="modal-body">
        <ng-container *ngFor="let group of vm.groups; index as index; last as last">
          <div>
            <div *ngIf="group.info.procurementType === 'sto'">
              Please select a delivery option for STO PO from supplying plant {{ group.info.vendorNumber }}.
            </div>
            <div *ngIf="group.info.procurementType === 'buyout'">
              Please select a delivery option for Buyout PO for vendor {{ group.info.vendorNumber }}.
            </div>
            <div *ngIf="group.info.procurementType === 'hotflag'">
              Please select a Requisition or Purchase Order option for each Hot Flag item.
            </div>
            <div *ngIf="group.info.procurementType === 'other'">
              Please select a delivery option for PO for vendor {{ group.info.vendorNumber }}.
            </div>
            <div>
              <order-item-list idSuffix="purchaseOrderCreateModal_groups[{{index}}]_orderItems" [orderItems]="group.orderItems" [showHotFlagColumn]="group.info.procurementType === 'hotflag'"></order-item-list>
            </div>
            <div class="form-group">
              <button *ngIf="group.state.showMore" id="purchaseOrderCreateModal_groups[{{index}}]_showLess"
                class="btn btn-secondary" type="button" (click)="showLess(index)">
                Show Less
              </button>
              <button *ngIf="group.hasMore && !group.state.showMore" id="purchaseOrderCreateModal_groups[{{index}}]_showMore"
                class="btn btn-secondary" type="button" (click)="showMore(index)">
                Show {{ group.moreCount }} More
              </button>
            </div>
            <ng-container *ngIf="group.info.procurementType !== 'hotflag'">
              <div *ngIf="group.info.procurementType === 'sto'" class="d-flex align-items-center">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_delivery" type="radio" name="deliveryType[{{index}}]" value="delivery"
                  [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event, group.info.goodSuppliers)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_delivery">
                  Delivery (Parts will be delivered to requesting branch by fulfilling branch delivery driver)
                </label>
              </div>
              <div class="d-flex align-items-center good-supplier-options-container">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_pickup" type="radio" name="deliveryTypePo[{{index}}]" value="pickup"
                  [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event, group.info.goodSuppliers)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_pickup">
                  Pickup (Parts will be picked up by requesting branch delivery driver)
                </label>
                <div class="d-flex flex-column w-100 good-supplier-options" *ngIf="group.state.deliveryType === 'pickup'">
                  <ng-container *ngIf="group.orderItems.length > 1 && group.info?.goodSuppliers?.length > 1">
                    <p id="mainSupplier_{{index}}_deliveryTypePo_pickup_title">Are all parts being pick up at the same supplier address?</p>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="mainSupplier_{{index}}_deliveryTypePo_pickup_yes"
                        [ngModel]="group.state.sameAddress"
                        (ngModelChange)="updateSameAddress(index, $event)"
                        [value]="true"
                        name="sameAddress[{{index}}]"
                        required>
                      <label class="form-check-label" for="mainSupplier_{{index}}_deliveryTypePo_pickup_yes">
                          Yes
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="mainSupplier_{{index}}_deliveryTypePo_pickup_no"
                        [ngModel]="group.state.sameAddress"
                        (ngModelChange)="updateSameAddress(index, $event)"
                        [value]="false"
                        name="sameAddress[{{index}}]"
                        required>
                      <label class="form-check-label" for="mainSupplier_{{index}}_deliveryTypePo_pickup_no">
                          No
                      </label>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="renderAddressDropdown(group.state.deliveryType, group.info.procurementType)">
                    <ng-container *ngIf="group.info?.goodSuppliers?.length === 1">
                      <span class="single-address-display">{{getGoodSupplierAddressString(group.info.goodSuppliers[0])}}</span>
                    </ng-container>
                    <select 
                      *ngIf="(group.info?.goodSuppliers?.length > 1 && group.state.sameAddress)
                      || (group.orderItems.length === 1 && group.info?.goodSuppliers?.length > 1)" 
                      id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_pickupAddress"
                      name="supplier[{{index}}]"
                      class="form-control {{group.info?.goodSuppliers?.length > 1 ? '' : 'd-none'}}"
                      [ngModel]="group.state.supplier"
                      (change)="updateSupplier(index, $event.target?.value)" 
                      [disabled]="disablePickupAddressOptions(group.info?.goodSuppliers ?? []) "
                      required
                    >
                      <option [value]="null" [defaultSelected]="group.info?.goodSuppliers?.length !== 1">Please select address</option>
                      <option 
                        *ngFor="let address of group.info.goodSuppliers; let j = index"
                        id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_pickupAddress_{{j}}" 
                        [value]="group.info.goodSuppliers[j].supplier"                    
                        [defaultSelected]="group.info?.goodSuppliers?.length === 1"
                      >
                        {{getGoodSupplierAddressString(group.info.goodSuppliers[j])}}
                      </option>
                    </select>
                    <ng-container *ngIf="group.state.sameAddress === false && renderVendors(group.info.goodSuppliers, group.orderItems)">
                      <div class="line-items-section" *ngIf="hasUnassignedItems(group.orderItems)">
                        <div class="title-of-box-hold">
                          <div class="title-of-box pull-left"><strong>Unassigned items</strong></div>
                          <div class="pull-right">
                            <input id="LineItemDetails_CheckBox_Unassigned_SelectedAll" type="checkbox"
                              name="LineItemDetails_CheckBox_Unassigned_SelectedAll"
                              [(ngModel)]="selectedAllUnassigned"
                              (change)="selectAllUnassignedChecked($event, group.orderItems)"/>
                            <label for="LineItemDetails_CheckBox_Unassigned_SelectedAll">Select all</label>
                          </div>
                        </div>
                        <table class="table w-100">
                          <thead class="d-none">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Part Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let item of noSupplierOrderItems(group.orderItems); let i = index">
                              <tr class="w-100">
                                <td style="width: 40px;">
                                  <input
                                    id="LineItemDetails_CheckBox_Unassigned_{{i}}"
                                    type="checkbox"
                                    name="unassigned_{{i}}"
                                    [(ngModel)]="item.checked"
                                    (change)="orderItemChecked(item)"/>
                                  <label for="LineItemDetails_CheckBox_Unassigned_{{i}}"></label>
                                </td>
                                <td id="LineItemDetails_CheckBox_Unassigned_{{i}}">
                                  {{item.partNumber}} - {{item.description}}
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                        <select 
                          id="purchaseOrderCreateModal__pickupAddress__select"
                          name="supplier[{{index}}]"
                          class="form-control mb-2"
                          (change)="setUnassignedSupplier($event.target?.value, group.orderItems)"
                          required
                        >
                          <option [value]="null" [defaultSelected]="group.info?.goodSuppliers?.length !== 1">Please select address</option>
                          <option 
                            *ngFor="let address of group.info.goodSuppliers; let j = index"
                            id="purchaseOrderCreateModal__pickupAddress_{{j}}" 
                            [value]="group.info.goodSuppliers[j].supplier"                    
                            [defaultSelected]="group.info?.goodSuppliers?.length === 1"
                          >
                            {{getGoodSupplierAddressString(group.info.goodSuppliers[j])}}
                          </option>
                        </select> 
                      </div>
                      <div class="line-items-section" *ngFor="let supplierItem of getSuppliersByOrderItems(group.orderItems); let idx = index">
                        <div class="title-of-box-hold">
                          <div class="title-of-box pull-left"><strong>{{getSupplierName(supplierItem, group.info.goodSuppliers)}}</strong></div>
                          <div class="pull-right">
                            <input
                              id="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_selectedAll"
                              type="checkbox"
                              name="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_selectedAll"
                              [checked]="isCheckedSupplierItem(supplierItem)"
                              (change)="selectAllChecked($event, supplierItem, group.orderItems)"/>
                            <label for="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_selectedAll">Select all</label>
                          </div>
                        </div>
                        <table class="table w-100">
                          <thead class="d-none">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Part Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let item of getOrderItemsBySupplier(group.orderItems, supplierItem); let i = index">
                              <tr class="w-100">
                                <td style="width: 40px;">
                                  <input
                                    id="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_{{i}}"
                                    type="checkbox"
                                    name="deliveryOption_{{supplierItem}}_Supplier_{{idx}}_{{i}}"
                                    [(ngModel)]="item.checked"
                                    (change)="orderItemChecked(item)"/>
                                  <label for="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_{{i}}"></label>
                                </td>
                                <td id="LineItemDetails_CheckBox_{{idx}}_{{supplierItem}}_{{i}}">
                                  {{item.partNumber}} - {{item.description}}
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                        <select 
                          id="purchaseOrderCreateModal__pickupAddress__select"
                          name="supplier[{{index}}]"
                          class="form-control mb-2"
                          (change)="setSupplier($event.target?.value, group.orderItems)"
                          required
                        >
                          <option [value]="null" [defaultSelected]="group.info?.goodSuppliers?.length !== 1">Please select address</option>
                          <option 
                            *ngFor="let address of group.info.goodSuppliers; let j = index"
                            id="purchaseOrderCreateModal__pickupAddress_{{j}}" 
                            [value]="group.info.goodSuppliers[j].supplier"                    
                            [defaultSelected]="group.info?.goodSuppliers?.length === 1"
                          >
                            {{getGoodSupplierAddressString(group.info.goodSuppliers[j])}}
                          </option>
                        </select>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <main-supplier-form *ngIf="group.state.deliveryType === 'pickup'" [group]="group" [index]="index"></main-supplier-form>
              <div class="d-flex align-items-center">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_freight" type="radio" name="deliveryType[{{index}}]" value="freight"
                  [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event, group.info.goodSuppliers)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_freight">
                  Ship (Parts will be shipped)
                </label>
              </div>
              <div class="d-flex align-items-center">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_other" type="radio" name="deliveryType[{{index}}]" value="other"
                  [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event, group.info.goodSuppliers)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_other">
                  Other (Parts will be picked up by the customer)
                </label>
              </div>
            </ng-container>
            <ng-container *ngIf="group.info.procurementType === 'hotflag'">
              <div class="d-flex align-items-center">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_hotflag_req" type="radio" name="deliveryType[{{index}}]" value="requisition"
                  [ngModel]="group.state.createRequestOnly" (ngModelChange)="updateHotFlagItems(index, $event)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_hotflag_req">
                  Create requisition only
                </label>
              </div>
              <div class="d-flex align-items-center">
                <input id="purchaseOrderCreateModal_groups[{{index}}]_hotflag_po" type="radio" name="deliveryType[{{index}}]" value="po"
                  [ngModel]="group.state.createRequestOnly" (ngModelChange)="updateHotFlagItems(index, $event)" required>
                <label for="purchaseOrderCreateModal_groups[{{index}}]_hotflag_po">
                  Create purchase order
                </label>
              </div>
              <div class="ps-3" *ngIf="group.state.createRequestOnly === 'po'">
                <div class="d-flex align-items-center good-supplier-options-container">
                  <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_pickup" type="radio" name="deliveryTypePo[{{index}}]" value="pickup"
                    [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event, group.info.goodSuppliers)" [required]="group.state.createRequestOnly === 'po'">
                  <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_pickup">
                    Pickup (Parts will be picked up by requesting branch delivery driver)
                  </label>
                  <div class="d-flex flex-column w-100" [ngClass]="{'good-supplier-options' : group.info?.goodSuppliers?.length > 0}" *ngIf="group.state.deliveryType === 'pickup'">
                    <ng-container *ngIf="group.orderItems.length > 1 && group.info?.goodSuppliers?.length > 1">
                      <p id="mainSupplier_{{index}}_deliveryTypePo_pickup_title">Are all parts being pick up at the same supplier address?</p>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="mainSupplier_{{index}}_deliveryTypePo_pickup_yes"
                          [ngModel]="group.state.sameAddress"
                          (ngModelChange)="updateSameAddress(index, $event)"
                          [value]="true"
                          name="sameAddress[{{index}}]"
                          [required]="group.state.createRequestOnly === 'po' && group.state.deliveryType === 'pickup'">
                        <label class="form-check-label" for="mainSupplier_{{index}}_deliveryTypePo_pickup_yes">
                            Yes
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="mainSupplier_{{index}}_deliveryTypePo_pickup_no"
                          [ngModel]="group.state.sameAddress"
                          (ngModelChange)="updateSameAddress(index, $event)"
                          [value]="false"
                          name="sameAddress[{{index}}]"
                          [required]="group.state.createRequestOnly === 'po' && group.state.deliveryType === 'pickup'">
                        <label class="form-check-label" for="mainSupplier_{{index}}_deliveryTypePo_pickup_no">
                            No
                        </label>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="renderAddressDropdown(group.state.deliveryType, group.info.procurementType)">
                      <ng-container *ngIf="group.info?.goodSuppliers?.length === 1">
                        <span class="single-address-display">{{getGoodSupplierAddressString(group.info.goodSuppliers[0])}}</span>
                      </ng-container>
                      <select 
                        *ngIf="(group.info?.goodSuppliers?.length > 1 && group.state.sameAddress)
                        || (group.orderItems.length === 1 && group.info?.goodSuppliers?.length > 1)" 
                        id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_pickupAddress"
                        name="supplier[{{index}}]"
                        class="form-control {{group.info?.goodSuppliers?.length > 1 ? '' : 'd-none'}}"
                        [ngModel]="group.state.supplier"
                        (change)="updateSupplier(index, $event.target?.value)" 
                        [disabled]="disablePickupAddressOptions(group.info.goodSuppliers)"
                        [required]="group.state.createRequestOnly === 'po' && group.state.deliveryType === 'pickup'">
                      >
                        <option [value]="null" [defaultSelected]="group.info?.goodSuppliers?.length !== 1">Please select address</option>
                        <option 
                          *ngFor="let address of group.info.goodSuppliers; let j = index"
                          id="purchaseOrderCreateModal_groups[{{index}}]_deliveryType_pickupAddress_{{j}}" 
                          [value]="group.info.goodSuppliers[j].supplier"                    
                          [defaultSelected]="group.info?.goodSuppliers?.length === 1"
                        >
                          {{getGoodSupplierAddressString(group.info.goodSuppliers[j])}}
                        </option>
                      </select>
                    </ng-container>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_freight" type="radio" name="deliveryTypePo[{{index}}]" value="freight"
                    [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event)" [required]="group.state.createRequestOnly === 'po'">
                  <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_freight">
                    Ship (Parts will be shipped)
                  </label>
                </div>
                <div class="d-flex align-items-center">
                  <input id="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_other" type="radio" name="deliveryTypePo[{{index}}]" value="other"
                    [ngModel]="group.state.deliveryType" (ngModelChange)="updateDeliveryType(index, $event)" [required]="group.state.createRequestOnly === 'po'">
                  <label for="purchaseOrderCreateModal_groups[{{index}}]_deliveryTypePo_other">
                    Other (Parts will be picked up by the customer)
                  </label>
                </div>
              </div>
            </ng-container>
          </div>
          <hr *ngIf="!last">
        </ng-container>
      </div>
      <div class="modal-footer">
        <div *ngIf="!ngForm.form.valid">Select an option for each line item or group</div>
        <button 
          id="purchaseOrderCreateModal_submit" 
          class="btn btn-primary" 
          type="submit" 
          [disabled]="isSubmitDisabled(ngForm.form.valid, vm.groups)">
          Submit
        </button>
      </div>
    </fieldset>
  </form>
</ng-container>
